import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
const trackCtaClick = (ctaName = "loyalty_cta", location = "loyalty") => {
    dispatchTrackingEvent(TrackingEvents.TrackingCtaClick, { cta_name: ctaName, cta_location: location });
};
export default trackCtaClick;
//# sourceMappingURL=trackCtaClick.js.map